import { AbstractListItemAction } from 'sulu-admin-bundle/views';

export default class CloneEntityAction extends AbstractListItemAction {
    getItemActionConfig(item) {
        const { disabled_ids: disabledIds = [] } = this.options;
        const { view: view = null } = this.options;

        return {
            icon: 'su-copy',
            disabled: item ? disabledIds.includes(item['id']) : true,
            onClick: item ? () => this.handleClick(view, item) : undefined,
        };
    }

    handleClick = (view, item) => {
        this.router.navigate(view, { id: item.id });
    };
}